// All imagery is self-hosted under /public/images. Each entry describes the
// responsive variants generated for it (AVIF with a JPEG fallback), so the
// <Picture> component can build srcsets and reserve layout space.
//
// To regenerate or add a variant, see scripts/optimize-images.sh.

const img = (name, w, h, widths) => ({ name, w, h, widths });

export const IMG = {
  logoForest: "/alabrad-logo-forest.png",
  logoCream: "/alabrad-logo-cream.png",

  hero: img("hero", 1264, 848, [640, 1024, 1264]),
  founder: img("founder", 848, 1264, [480, 848]),
  coldChain: img("cold-chain", 1264, 848, [640, 1024, 1264]),
  healthyFlock: img("healthy-flock", 1264, 848, [640, 1024, 1264]),
  vetExamining: img("vet-examining", 848, 1264, [480, 848]),

  // Full-bleed photography for the hero slider and the mid-page photo bands.
  // These run edge to edge on wide screens, hence the extra 1920 variant.
  flockScale: img("flock-scale", 1920, 1280, [640, 1024, 1600, 1920]),
  freeRange: img("free-range", 1920, 1278, [640, 1024, 1600, 1920]),
  farmyard: img("farmyard", 1920, 1280, [640, 1024, 1600, 1920]),
  eggTrays: img("egg-trays", 1920, 2486, [640, 1024, 1600, 1920]),

  // Home-page category tile for poultry vaccines: the real Vaksimune range,
  // composed in scripts/ from the same product photos the product pages use.
  vaccinesLineup: img("vaccines-lineup", 1600, 1200, [640, 1024, 1600]),
  feedLineup: img("feed-lineup", 1600, 1200, [640, 1024, 1600]),

  // products
  vaccineLiquid: img("vaccine-liquid", 1024, 1024, [400, 800, 1024]),
  vaccineTray: img("vaccine-tray", 1024, 1024, [400, 800, 1024]),
  vaccineBottle: img("vaccine-bottle", 1024, 1024, [400, 800, 1024]),
  feedJar: img("feed-jar", 1024, 1024, [400, 800, 1024]),
  electrolyte: img("electrolyte", 1024, 1024, [400, 800, 1024]),
  probiotic: img("probiotic", 1024, 1024, [400, 800, 1024]),
  amnil: img("amnil", 1024, 1024, [400, 800, 1024]),
  enspiraPhytase: img("enspira-phytase", 1024, 1024, [400, 800, 1024]),
  enspira: img("enspira-bag", 1024, 1024, [400, 800, 1024]),
  novelaEcl: img("novela-eclplus", 1024, 1024, [400, 800, 1024]),
  coryzaColi: img("vaksimune-coryza-coli", 1024, 1024, [400, 800, 1024]),
  ibNv2: img("vaksimune-ib-nv2", 1024, 1024, [400, 800, 1024]),
  ibdD: img("vaksimune-ibd-d", 1024, 1024, [400, 800, 1024]),
  ibdMhv: img("vaksimune-ibd-mhv", 1024, 1024, [400, 800, 1024]),
  ibhDuo: img("vaksimune-ibh-duo", 1024, 1024, [400, 800, 1024]),
  ilt: img("vaksimune-ilt", 1024, 1024, [400, 800, 1024]),
  ndBanAf: img("vaksimune-nd-banaf", 1024, 1024, [400, 800, 1024]),
  ndClone: img("vaksimune-nd-clone", 1024, 1024, [400, 800, 1024]),
  ndCloneIb: img("vaksimune-nd-clone-ib", 1024, 1024, [400, 800, 1024]),
  ndlIbPlusEds: img("vaksimune-ndl-ibplus-eds", 1024, 1024, [400, 800, 1024]),
  ndlMulti: img("vaksimune-ndl-multi", 1024, 1024, [400, 800, 1024]),
  ndlH9: img("vaksimune-ndl-h9", 1024, 1024, [400, 800, 1024]),
  pox: img("vaksimune-pox", 1024, 1024, [400, 800, 1024]),

  barn: img("barn", 1600, 1066, [640, 1024, 1600]),
};

// Largest JPEG variant — used as the <img src> fallback and for og:image style
// absolute URLs where a single file is required.
export const imgSrc = (entry) =>
  `/images/${entry.name}-${entry.widths[entry.widths.length - 1]}.jpg`;

export const imgSrcSet = (entry, ext) =>
  entry.widths.map((w) => `/images/${entry.name}-${w}.${ext} ${w}w`).join(", ");
